import { useQuery } from "@tanstack/react-query";

import { useSwitches } from "@hooks/useSwitches";
import useSystemStore from "@store/useSystemStore";
import dealService from "@services/deal.service";
import { DEAL_STAGES_QUERY_KEY, QUERY_CACHE_DEFAULT_EXPIRATION_MS } from "@config/query";
import { DealStageStatus } from "@enums/common.enum";

export function useDealStages() {
  const { isAppActive } = useSystemStore();
  const { isAvailable } = useSwitches();

  const { data, error, isLoading, fetchStatus, isPlaceholderData, refetch } = useQuery({
    enabled: isAppActive,
    queryKey: [DEAL_STAGES_QUERY_KEY],
    queryFn: async () => {
      return await dealService.getDealStages();
    },
    staleTime: QUERY_CACHE_DEFAULT_EXPIRATION_MS,
    select: (data) => {
      return {
        ...data,
        results: isAvailable("COMPANIES_AND_PEOPLE")
          ? data.results
          : data.results.filter((stage) => stage.status !== DealStageStatus.PORTFOLIO),
      };
    },
  });

  return { data, error, isLoading, fetchStatus, isPlaceholderData, refetch };
}
